import { Link as RouterLink } from 'react-router-dom'
import { formatURL } from 'utils/helpers'
import themes from 'utils/themes'
import Content from 'components/Content'
import { Card, CardContent, Link, Stack, Typography } from '@mui/material'

export default function HomePage() {
  const links = ['andrea', 'brett', 'ben', 'vera'].map(name => ({
    label: name,
    link: formatURL(name),
    color: themes[`${name}Theme`].palette.primary.main,
  }))

  return (
    <Content bgColor='gradient'>
      <Stack
        spacing={2}
        useFlexGap
        alignItems='center'
        width={{ xs: '100%', sm: '70%' }}>
        <Stack flexDirection='row' gap={2} mb={4}>
          <Typography
            variant='h1'
            color='primary.main'
            fontSize='clamp(3rem, 10vw, 3.5rem)'
            ml={2}
            sx={theme => ({
              ...theme.applyStyles('dark', { color: 'primary.light' }),
            })}>
            HERRMANN
          </Typography>
          <Typography
            variant='h1'
            display='flex'
            alignItems='center'
            fontSize='clamp(3rem, 10vw, 3.5rem)'>
            Media
          </Typography>
        </Stack>
        <Typography variant='h6' color='gray'>
          Family:
        </Typography>
        <Stack flexDirection='row' gap={2}>
          {links.map(({ color, label, link }) => (
            <Link
              key={label}
              to={link}
              underline='none'
              color={color}
              sx={{ transition: '0.2s all ease-in-out' }}
              component={RouterLink}>
              <Card
                sx={{
                  border: '2px solid transparent',
                  borderRadius: 2,
                  '&:hover': { borderColor: color, boxShadow: 4 },
                }}>
                <CardContent>
                  <Typography
                    variant='h4'
                    textTransform='capitalize'
                    color={color}>
                    {label}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          ))}
        </Stack>
      </Stack>
    </Content>
  )
}
